import {setOrFallbackValue} from './helper';
export default class FitterFee {
    constructor(props) {
        this.type = setOrFallbackValue(props, 'type', null);
        this.productUnitQty = setOrFallbackValue(props, 'productUnitQty', null);
        this.amount = setOrFallbackValue(props, 'amount', null);
    }
}
